import { defineComponent as _defineComponent } from 'vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { storeToRefs } from 'pinia'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePadletLogoInScreenshotMode',
  setup(__props) {

const surfaceStore = useSurfaceStore()
const { isMap, colorScheme, backgroundLuminance } = storeToRefs(surfaceStore)

return { __sfc: true,surfaceStore, isMap, colorScheme, backgroundLuminance }
}

})